import { NavigationExtras } from '@angular/router';

export const FORCED_NAV_STATE = { forced: true } as const;

export const FORCED_NAV: NavigationExtras = { state: FORCED_NAV_STATE };

export function isForcedNavigation(extras: NavigationExtras | undefined): boolean {
  if (!extras) {
    return false;
  }
  return extras.state?.['forced'] === true;
}
